module.exports = __webpack_public_path__ + "img/booming.5b8411ec.svg";